import { render } from "./ButtonPass.vue?vue&type=template&id=5d96b484"
import script from "./ButtonPass.vue?vue&type=script&lang=js"
export * from "./ButtonPass.vue?vue&type=script&lang=js"

import "./ButtonPass.vue?vue&type=style&index=0&id=5d96b484&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__